import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "@ant-design/compatible/assets/index.css";
import {
  Select,
  InputNumber,
  Button,
  Collapse,
  Checkbox,
  Badge,
  DatePicker,
  Tooltip,
  Icon,
} from "antd";
import { Form } from "@ant-design/compatible";
import moment from "moment";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { relativeTimeThreshold } from "moment";

const { Option } = Select;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const formTailLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 8,
    offset: 5,
  },
};

class EnvironmentImpact extends React.Component {
  constructor() {
    super();
  }

  componentDidMount = async () => {
    try {
      await this.props.getEnvironImpactVal();
      const env_impact_obj = this.props.qcApi.qcEnvGetData.reduce(function (
        acc,
        curr
      ) {
        if (!acc[curr.key]) {
          acc[curr.key] = curr.value;
        }
        return acc;
      },
      {});
      this.props.form.setFieldsValue({
        trees: env_impact_obj.trees,
        air_pollution: env_impact_obj.air_pollution,
        water: env_impact_obj.water,
        land_fill: env_impact_obj.land_fill,
        gasoline: env_impact_obj.gasoline,
        energy: env_impact_obj.energy,
      });
    } catch (e) {
      console.log(e);
    }
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.props.updateEnvironmentImpact(values);
      }
    });
  };
  addEnvironmentImpactDaily = async (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const {
          _trees,
          _air_pollution,
          _water,
          _land_fill,
          _gasoline,
          _energy,
        } = values;
        values.trees = Number(values.trees) + _trees;
        values.trees = Number(values.trees) + _trees;
        values.air_pollution = Number(values.air_pollution) + _air_pollution;
        values.water = Number(values.water) + _water;
        values.land_fill = Number(values.land_fill) + _land_fill;
        values.gasoline = Number(values.gasoline) + _gasoline;
        values.energy = Number(values.energy) + _energy;

        this.props.updateEnvironmentImpact(values);
      }
    });
  };
  /*   handleHmgChange = async(e) =>{
        await this.props.notificationSetHmg(e);
        const hmg_list =this.props.notifications_api.hmgListSelected;
        this.setState({hmg_ids:hmg_list});
    } */

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        onSubmit={this.handleSubmit}
      >
        <div className="container_ab">
          <Collapse defaultActiveKey={["1"]} expandIconPosition={"right"}>
            <Panel header="Total Environmental Impact" key="1">
              <Form.Item label="Trees">
                {getFieldDecorator("trees", {
                  rules: [
                    {
                      required: true,
                      message: "Please insert number of Trees!",
                    },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Air Pollution">
                {getFieldDecorator("air_pollution", {
                  rules: [
                    { required: true, message: "Please insert Air Pollution!" },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Water">
                {getFieldDecorator("water", {
                  rules: [
                    {
                      required: true,
                      message: "Please insert Water Quantity!",
                    },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Landfill">
                {getFieldDecorator("land_fill", {
                  rules: [
                    { required: true, message: "Please insert  LandFill!" },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Gasoline">
                {getFieldDecorator("gasoline", {
                  rules: [
                    { required: true, message: "Please insert  Gasoline!" },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Energy">
                {getFieldDecorator("energy", {
                  rules: [
                    { required: true, message: "Please insert  Energy!" },
                  ],
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>

              <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={["1"]} expandIconPosition={"right"}>
            <Panel header="Add Daily Environmental Impact" key="1">
              <Form.Item label="Trees">
                {getFieldDecorator("_trees", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Air Pollution">
                {getFieldDecorator("_air_pollution", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Water">
                {getFieldDecorator("_water", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Landfill">
                {getFieldDecorator("_land_fill", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Gasoline">
                {getFieldDecorator("_gasoline", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>
              <Form.Item label="Energy">
                {getFieldDecorator("_energy", {
                  initialValue: 0,
                })(<InputNumber className="mdo_custom_inputs" />)}
              </Form.Item>

              <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                <Button type="primary" onClick={this.addEnvironmentImpactDaily}>
                  Add
                </Button>
              </Form.Item>
            </Panel>
          </Collapse>
        </div>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "environ-impact" })(EnvironmentImpact);
const mapStateToProps = (state) => {
  return {
    qcApi: state.qcApi,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getEnvironImpactVal: () => dispatch(actions.getEnvironImpactVal()),
  updateEnvironmentImpact: (data) =>
    dispatch(actions.updateEnvironmentImpact(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(WrappedApp);
